import { OpaqueToken } from '@angular/core';

// import translations
import { LANG_KO_NAME, LANG_KO_TRANS } from './lang-ko';
import { LANG_EN_NAME, LANG_EN_TRANS } from './lang-en';

// translation token
export const TRANSLATIONS = new OpaqueToken('translations');

// all translations
export const dictionary = {
    'ko': LANG_KO_TRANS, 
    'en': LANG_EN_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary }
];


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/translate/translations.ts